angular.module('aprima-core-ui').directive('apFeatureCheck', [ 'ServerInfoRepository', function (ServerInfoRepository) {
    'use strict';

    return {
        restrict: 'A',
        scope: {
            requiredFeatures: '@'
        },
        link: function (scope, element) {
            if(scope.requiredFeatures){
                var splitRequiredFeatures = scope.requiredFeatures.split(',');
                var isSupported = ServerInfoRepository.isFeatureSupported(splitRequiredFeatures);

                if(!isSupported){
                    // only calling $destroy here because this is using an isolate scope for this directive
                    // that can be safely destroyed when this element is removed
                    // don't do this if it's sharing an outer scope with some other element, or there will likely be issues
                    scope.$destroy();
                    element.remove();
                }
            }
        }
    };
}]);